import { get } from 'vio-libs';
export function getCurrentUser(consumerAPI = false) {
    if (!consumerAPI) {
        return get('current-user');
    }
    return get('v1/user?expand=memberships.roles,memberships.organization', undefined, true);
}
